"use client"

import type { PartnerCapability } from "@/schema/company"

import { canAccessPartnerFeature } from "@/lib/partner-access"
import { useFetchCurrentUser } from "@/hooks/api/users"

export function usePartnerAccess(capability: PartnerCapability) {
  const user = useFetchCurrentUser()

  return {
    enabled: canAccessPartnerFeature(
      user.data?.company.company_type,
      user.data?.company.partner_settings?.capabilities,
      capability
    ),
    isLoading: user.isPending,
    isError: user.isError,
  }
}
